<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import { Validator } from "vee-validate";
import openapi from "@/api/openapi.js";

export default {
  data() {
    return {
      isRouterAlive: true,
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$i18n.locale"(val) {
      // 切换中英文
      Validator.localize(val);
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
    getUsers() {
      this.$tools
        .ajax(openapi.Member, "get", { status: "APPROVED" }, 3)
        .then((data) => {
          let users = [];
          data.forEach((u) => {
            users.push(u.user);
          });
          this.$store.commit("UPDATE_USERS", users);
        });
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    if (this.$store.state.myUsers.length>0) {
      this.getUsers();
    }
  },
  async created() {
    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/tree.scss";
:root {
  --success: #28c76f;
  --warning: #ff9f43;
  --primary: rgb(30, 101, 181);
  --grey: #b8c2cc;
  --danger: #ea5455;
}
// font classes added
@for $i from 10 through 20 {
  .font-#{$i} {
    font-size: #{$i}px !important;
  }
}
.hide_tabs .con-ul-tabs {
  display: none !important;
}
.EyeIcon svg {
  height: 18px !important;
  width: 18px !important;
}
.v-select.small,
.vs-input.small {
  width: 200px;
}
.vs-input.xs {
  width: 90px;
}
.small-select.v-select {
  width: 200px;
  .vs__selected-options {
    width: 80%;
  }
}
.table-responsive table {
  width: 100% !important;
  min-width: 100%;
}
.light-grey {
  color: #bbb;
}
.soft-select.v-select {
  width: 130px;
  .vs__selected-options {
    width: 80%;
  }
}
.type-select.v-select {
  width: 170px;
  .vs__selected-options {
    width: 85%;
  }
}
.owner-Select.v-select {
  width: 220px;
  .vs__selected-options {
    width: 90%;
  }
}
.owner-Select-small.v-select {
  width: 180px;
  .vs__selected-options {
    width: 90%;
  }
}
.vs-table .min-width {
  width: 150px;
}
.vs-table .mid-width {
  width: 180px;
}
.owner-Select-small.v-select,
.owner-Select.v-select,
.soft-select.v-select,
.type-select.v-select {
  white-space: nowrap;
  display: inline-block;
  .vs__dropdown-menu {
    min-width: 10px;
  }
  .vs__dropdown-toggle {
    padding: 0px;
    .vs__selected-options {
      .vs__selected {
        margin: 0px 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        width: 90%;
      }
    }

    .vs__search {
      margin: 0px;
      padding: 0px;
    }

    .vs__actions {
      padding: 4px 2px 0 2px;
      .vs__open-indicator {
        bottom: 1px;
        color: #888;
      }
    }
  }
  .vs__dropdown-menu {
    z-index: 9999999999;
    li {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.no-clear.v-select {
  .vs__selected {
    cursor: pointer;
  }
  .vs__clear {
    display: none;
  }
}
.fullwidth.con-vs-tabs .line-vs-tabs {
  opacity: 0;
}
.fullwidth.con-vs-tabs .con-slot-tabs {
  width: 100% !important;
}
.fullwidth.vs-tabs-position-left .ul-tabs-left {
  width: 200px !important;
  padding: 55px 5px 0;
  min-height: calc(100vh);
  background: #fff;
}
.fullwidth.vs-tabs-position-left .ul-tabs-left .vs-tabs--btn {
  font-size: 14px !important;
  color: #333;
  text-align: left;
  .vs-icon {
    color: #333;
  }
}
.fullwidth.vs-tabs-position-left .ul-tabs-left .vs-tabs--li.activeChild {
  .vs-tabs--btn {
    background: var(--primary);
    border-radius: 5px;
    color: #fff !important;
    .vs-icon {
      color: #fff;
    }
  }
}
.parent_even {
  color: darken(rgb(30, 101, 181), 15%);
  .child_even {
    color: #598fca;
  }
  .child_odd {
    color: rgb(30, 101, 181);
  }
}
.error input,
.select_error .vs__dropdown-toggle {
  border: 1px solid var(--danger) !important;
}
.parent_odd {
  color: darken(#28c76f, 15%);
  .child_even {
    color: #4dde8d;
  }
  .child_odd {
    color: #28c76f;
  }
}
.back-btn {
  width: 60px;
  z-index: 5;
  font-weight: bold;
  color: var(--primary);
}
.status_changer {
  .vs__search {
    border: none !important;
  }
  &.IN_PROGRESS,
  &.IN_REVIEW {
    background: var(--primary);
    .vs__dropdown-toggle {
      border-color: var(--primary);
    }
    color: #fff;
    .vs__selected {
      color: #fff;
    }
  }
  &.DONE,
  &.CLOSED,
  &.APPROVED {
    background: var(--success);
    .vs__dropdown-toggle {
      border-color: var(--success);
    }
    color: #fff;
    .vs__selected {
      color: #fff;
    }
  }
  &.REJECTED {
    background: var(--warning);
    .vs__dropdown-toggle {
      border-color: var(--warning);
    }
    color: #fff;
    .vs__selected {
      color: #fff;
    }
  }
  &.NEW,
  &.TO_DO,
  &.TODO {
    background: var(--grey);
    .vs__dropdown-toggle {
      border-color: var(--grey);
    }
    color: #000;
    .vs__selected {
      color: #000;
    }
  }
}
.no-close-all .con-chips--remove-all {
  display: none;
}
.nowrap {
  white-space: nowrap !important;
}
.go-back-btn {
  color: var(--primary);
}
.red-mark {
  label.vs-input--label,
  label.vs-select--label,
  label.select-label {
    position: relative;
    &::after {
      content: "*";
      position: absolute;
      right: -10px;
      top: 0;
      color: #333;
    }
  }
}
.green-mark {
  label.vs-input--label,
  label.vs-select--label,
  label.select-label {
    position: relative;
    &::after {
      content: "*";
      position: absolute;
      right: -10px;
      top: 0;
      color: green;
    }
  }
}
.v-select-label {
  label {
    padding-left: 5px;
    font-size: 0.85rem;
    color: rgba(0, 0, 0, 0.7);
  }
}
.search-input {
  .vs-con-input {
    // z-index: 50000;
    border: 0;
  }
  .vs-input--input.normal {
    padding: 0.4rem;
    padding-left: 22px;
    padding-top: 4px;
  }
  .input-span-placeholder.vs-input--placeholder.normal {
    padding: 0.4rem;
    padding-left: 24px;
    top: 0;
  }
  .vs-input--input:focus + .vs-input--placeholder {
    transform: none;
  }
}
.small .vs-input--input,
.small .input-span-placeholder.vs-input--placeholder,
.xs .vs-input--input,
.xs .input-span-placeholder.vs-input--placeholder {
  padding: 5px !important;
}

.small-select {
  .vs__dropdown-toggle {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 12px;
  }
  .vs__selected,
  .vs__search {
    margin: 0 !important;
    padding: 0 !important;
    margin-left: 5px !important;
  }
  &.no-border {
    cursor: pointer;
    .vs__actions {
      display: none;
    }
    .vs__dropdown-toggle {
      border: none;
    }
  }
}
#editor {
  img {
    max-height: 100px;
    max-width: 60% !important;
    margin-right: 5px;
  }
}
.disableClick * {
  pointer-events: none !important;
}
.vs-table {
  th .sort-th,
  th .vs-table-text {
    justify-content: center;
  }
  .td.vs-table--td {
    text-align: center;
  }
}
.text-capitalize {
  .vs__dropdown-menu {
    li {
      text-transform: capitalize;
    }
  }
  .vs__selected {
    text-transform: capitalize;
  }
}
.ticket-setting-container {
  .con-vs-tabs .con-slot-tabs {
    padding-bottom: 100px;
    .con-tab.vs-tabs--content {
      padding-left: 20px;
    }
  }
}
.activity {
  img {
    max-width: 50px;
  }
}
.hide_empty_message .not-data-table {
  display: none;
}

.after_submited .ticket_info .vs-table--not-data {
  display: none;
}
.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  transform: none !important;
}
.data_table table {
  border-collapse: inherit;
}
.ck.ck-editor__main > .ck-editor__editable {
  min-height: 200px;
}
div.add {
  color: var(--primary);
  font-weight: bold;
  // z-index: 50000;
}
::placeholder {
  color: #ccc;
}
.no-chips .vs__selected {
  display: none;
}
.license-container {
  .ul-tabs {
    box-shadow: none;
    .vs-tabs--li {
      padding-right: 25px !important;
      .vs-tabs--btn {
        padding: 5px 0 !important;
        text-align: left;
        color: #333;
        white-space: nowrap;
      }
      &.activeChild .vs-tabs--btn {
        padding: 5px 0 !important;
        color: var(--primary);
        font-weight: bold;
      }
    }
  }
}
.small {
  .vs-checkbox {
    height: 14px;
    width: 14px;
  }
}
.Ticket_Detail_Page {
  .dynamic-editor {
    .ql-container.ql-snow {
      border: none;
    }
    .ql-editor {
      min-height: 50px;
      border: 1px solid #f9f9f9;
      border-radius: 3px;
      &:focus,
      &:hover {
        border: 1px solid #eee;
      }
    }
    .ql-editor:focus .ql-toolbar {
      display: block;
    }
    .ql-snow.ql-toolbar {
      display: none;
    }
  }
  .dynamic-input input {
    font-size: 17px !important;
    border: 1px solid #e3dfdf !important;
    &:focus,
    &:hover {
      box-shadow: none;
      border: 1px solid #e3dfdf !important;
    }
  }
}
.dynamic-image-editor {
  width: 150%;
  height: 100px;
  margin-left: 20px;
  .ql-container {
    border-radius: 5px;
    border-top: 1px solid #ccc !important;
  }
  .ql-editor {
    min-height: 50px;
    border-radius: 3px;
  }
  .ql-snow.ql-toolbar {
    display: none;
  }
}
.comment_col .title {
  font-size: 15px;
}
.comment_col .vs-tabs button {
  font-size: 15px !important;
}
.comment_col .vs-tabs .font12{
  font-size: 12px !important;
}
.no-hover-bg:hover,
.no-hover-bg:focus {
  background: transparent !important;
}
.templateTable .vs-table--thead tr {
  border: 2px solid transparent;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  .vs-table--thead tr {
    background-color: #eee;
    th .vs-table-text {
      justify-content: center;
    }
    th:first-child .vs-table-text,
    th.flex-start .vs-table-text {
      justify-content: flex-start;
    }
    th.flex-end .vs-table-text {
      justify-content: flex-end;
    }
    th.flex-center .vs-table-text {
      justify-content: center;
    }
  }
  tr.tr-values td:first-child,
  tr.tr-values td.flex-start {
    text-align: left !important;
  }
  tr.tr-values td.flex-center {
    text-align: center !important;
  }
  // event is in right 编辑 图标靠右
  tr.tr-values td:last-child {
    text-align: right;
  }
  .tr-values.hoverFlat:not(.activeEdit):not(.is-expand):hover {
    opacity: 1;
  }
  tr:hover {
    background-color: #f7f7f7;
  }
}
.no-effect tr.tr-values:hover {
  background-color: #fff !important;
}
.w-100 {
  width: 100px;
}
.primary {
  color: rgba(var(--vs-primary), 1) !important;
}
.page-card.vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 0 1.5rem 1rem;
}
.page-card-projectdocument.vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 0;
  .vs-con-table .con-tablex .vs-table--thead .td-check {
    width: 80px;
  }
}
.vs-popup--close:hover {
  transform: translate(8px, -8px) !important;
}
.is-member {
  font-size: 20px !important;
  position: relative;
  top: 2px;
  color: grey;
  &.is-leader {
    color: rgb(26, 173, 25);
  }
}
.content-area__content {
  padding-bottom: 40px;
}
.hardware {
  .vs-popup--content {
    overflow-x: hidden;
    overflow-y: auto;
  }
  .vs-popup {
    width: auto !important;
    text-align: left;
  }
}
.img-responsive {
  max-width: 100%;
  max-height: 100vh;
  height: auto;
}
.responsive-img {
  max-height: 200px;
  max-width: 200px;
}
.link-style {
  color: var(--primary);
  &:hover,
  &:focus {
    text-decoration: underline;
  }
}
// 树的样式
.halo-tree {
  li {
    position: relative;
    padding-right: 0;
  }

  &.topLevel {
    .node-title {
      border: 1px solid #626262;

      &.node-selected {
        background: rgba(var(--vs-primary), 0.08);
        border: 1px solid rgb(30, 101, 181);
        // border: 1px solid #7367F0;
        color: rgb(30, 101, 181);
        // color: #7367F0;
        // background-color: red;
      }
    }

    .tr {
      display: inline-flex;
      justify-content: space-between;
      align-items: center;

      .btn-group {
        position: absolute;
        right: 10px;
        padding: 3px 6px;

        button {
          padding: 0 !important;
          vertical-align: middle;

          &:first-child {
            margin-right: 10px !important;
          }
        }
      }
    }
  }

  &.topLevel > li {
    padding: 0;
    margin-top: 10px;

    &::before,
    &::after {
      display: none;
    }
  }
}

.vue-directive-image-previewer {
  z-index: 9999999 !important;
}
// steps
.steps-form {
  display: table;
  width: 100%;
  position: relative;
}
.steps-form .steps-row {
  display: flex;
  justify-content: space-around;
}
.steps-form .steps-row:before {
  top: 14px;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 100%;
  height: 1px;
  background-color: #ccc;
}
.steps-form .steps-row .steps-step {
  text-align: center;
  position: relative;
}
.steps-form .steps-row .steps-step.complete .btn-circle {
  background-color: var(--primary);
}
.steps-form .steps-row .steps-step .btn-circle {
  width: 30px;
  display: inline-block;
  padding: 6px 0;
  color: #fff;
  background-color: #bbb;
  font-size: 12px;
  border-radius: 15px;
  margin-top: 0;
}
.filter-time {
  & > span:not(:first-child) {
    color: var(--primary);
    cursor: pointer;
  }
}
.filter-flatpickr.flatpickr-input {
  padding: 0.4rem;
  width: 150px;
}
.cursor-grab {
  cursor: grab;
}
// steps
.kanban .vs-list--header {
  background: #f3f3f3;
  padding: 10px 15px;
}
.kanban .vs-list {
  min-height: 400px;
  border: 1px solid #f3f3f3;
  box-shadow: 2px 5px 12px #ddd;
  padding: 0;
  border-radius: 5px;
}
.kanban .vs-list .vs-list--item {
  margin-bottom: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 8px;
  box-shadow: 1px 1px 3px #ddd;
}
.classic .vs-table--thead .td-check {
  opacity: 0;
}
.classic .td-check {
  padding: 0 !important;
  width: 20px;
}
// custom-menu for TabView
.TabViewMenu {
  .vx-navbar-wrapper {
    position: relative !important;
    right: 0;
    z-index: 1;
    width: 100% !important;
    height: 56px;
    .vs-navbar.navbar-skelton {
      background: transparent !important;
      box-shadow: none;
    }
    .the-navbar__user-meta .parent-dropdown {
      position: relative;
      z-index: 999999;
    }
  }
}
.router-tab__header {
  // max-width: calc(100% - 250px) !important;
  .router-tab__scroll {
    .router-tab__item {
      &:hover,
      &:focus {
        color: var(--primary);
      }
      &.is-active {
        background-color: #fff;
        color: var(--primary);
      }
    }
  }
}
.project_detial_menu {
  .vx-navbar-wrapper {
    background: #fff;
    // top: -20px;
    left: -2px;
  }
}
.sticky-header {
  header {
    position: sticky;
    top: -10px;
    z-index: 999999;
    > div {
      padding: 10px 0;
      background-color: #fff;
    }
  }
}
.tooltip {
  // ...

  &.info {
    $color: var(--primary);

    .tooltip-inner {
      background: $color;
      color: white;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
      max-width: 250px;
    }

    .tooltip-arrow {
      border-color: $color;
    }
  }
}
.steper {
  display: inline-block;
  li {
    width: 2em;
    height: 2em;
    text-align: center;
    line-height: 2em;
    border-radius: 1em;
    background: #ccc;
    margin: 0 1em 10px;
    display: inline-block;
    color: white;
    user-select: none;
    position: relative;
    z-index: 1;
    cursor: pointer;
  }

  li::after {
    content: "";
    position: absolute;
    top: 0.9em;
    right: 0em;
    width: 4em;
    height: 0.2em;
    background: #ccc;
    z-index: -1;
  }

  li:first-child::after {
    display: none;
  }

  li.active {
    background: #87add8;
  }

  li.active::after {
    background: #87add8;
  }

  li.complete {
    background: var(--primary);
  }
  li.complete::after {
    background: var(--primary);
  }
  .active ~ li {
    background: #ccc;
  }

  .active ~ li::after {
    background: #ccc;
  }
}
.popup_botton_close_hidden .vs-popup--header .vs-popup--close--icon{
  display: none;
}

.hidden_tree_open_close{
  .halo-tree{
    .tree-node-el{
      .tree-expand{
        display: none;
      }
    }
  }
}
.check_font_16 .vs-checkbox {
  height: 16px;
  width: 16px
}

</style>